import { tss } from "tss-react";

const useStyles = tss.create({
    rootVerticalColorPalette: {
        position: "relative",
        height: 36,
        width: 36,
        display: "inline-block",
    },
});

type IProps = {
    colors: any;
    width?: number;
};

export default function VerticalColorPalette(props: IProps) {
    const { classes } = useStyles();
    var { width, colors } = props;
    var length = colors.length;
    //console.log("VerticalColorPalette:colors", colors);
    return (
        <div className={classes.rootVerticalColorPalette} style={{ width: width ? width : 5 }}>
            {props.colors.map((color: string, index: number) => (
                <div
                    key={"vcolor-" + index}
                    style={{
                        backgroundColor: color,
                        height: 100 / length + "%",
                        width: 36,
                    }}
                >
                    &nbsp;
                </div>
            ))}
        </div>
    );
}
